import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MensagemExcecaoComponent } from './mensagem-excecao.component';
import { HttpClientModule } from '@angular/common/http';
import { MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatSelectModule, MatDatepickerModule, MatCheckboxModule, MatTableModule, MatPaginatorModule, MatNativeDateModule, MatDialogModule, MatTooltipModule, MatCardModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { NgxLoadingModule } from 'ngx-loading';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { ModalCadastroExcecaoModule } from './modal-cadastro-excecao/modal-cadastro-excecao.module';


const routes = [
    {
      path: 'mensagemExcecao',
      component: MensagemExcecaoComponent
    }
  ];

@NgModule({
  declarations: [MensagemExcecaoComponent],
  imports: [
     CommonModule,
     RouterModule.forChild(routes),
     SharedModule,
     MatButtonModule,
     MatFormFieldModule,
     MatIconModule,
     MatInputModule,
     MatSelectModule,
     MatDatepickerModule,
     MatCheckboxModule,
     MatTableModule,
     MatPaginatorModule,
     MatNativeDateModule,
     MatDialogModule,
     MatTooltipModule,
     HttpClientModule,
     NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
     MatCardModule,
     MatDialogModule,
     FormsModule,
      ModalCadastroExcecaoModule
  
     
   ],
   exports: [MensagemExcecaoComponent]
 })
export class MensagemExcecaoModule { }
